import { render, staticRenderFns } from "./RecoveryForm.vue?vue&type=template&id=775764ca"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports